import Vue from 'vue';
import { CellRendererService } from '@/helpers/renderService'

const renderService = new CellRendererService()

export const formatNumber = (value, minimumFractionDigits = 2, maximumFractionDigits) => {
  if (typeof value === 'number') {
    return value.toLocaleString('ru-RU', {minimumFractionDigits, maximumFractionDigits});
  }
};

export const alignForNumber = (value) => {
  if (value === undefined || value === ' ') {
    return {textAlign: 'left'};
  } else if (typeof value === 'number') {
    return {textAlign: 'right'};
  } else {
    return {textAlign: 'center'}
  }
};

export const alignCells = (cell, defaultAlign) => {
  const value = cell.value;
  if (cell.column.colId.includes('ag-Grid-AutoColumn')) {
    return {textAlign: 'left'};
  } else if (value === undefined || value === ' ') {
    return {textAlign: 'left'};
  } else if (typeof value === 'number') {
    return {textAlign: 'right'};
  } else {
    return {textAlign: defaultAlign || 'center'};
  }
};

export const addGroupingInResponseData = (responseData) => {
  if (responseData) {
    for (let i = 0; i < responseData.length; i++) {
      responseData[i].grouping = ' ';
      for (const key in responseData[i]) {
        if (key === 'children') {
          if (responseData[i].hasOwnProperty(key)) {
            responseData[i][key].forEach((item) => {
              item.grouping = ' ';
            });
          }
        }
      }
    }

    return responseData;
  }
};

export const getNodeChildDetails = (rowItem) => {
  if (rowItem.children && rowItem.children.length) {
    return {
      expanded: false,
      group: true,
      children: rowItem.children,
      key: rowItem.grouping
    };
  }

  return null;
};

const linkCellRendererUtil = (options) => {
  const { prop, url, otherAppFlag, differenceEntities, param } = options
  let linkUrl;
  const currentUrl = window.location.origin;
  const linkText = param.value ? param.value : '';
  if (param.data && param.data[prop]) {
    if (otherAppFlag) {
      linkUrl = `${currentUrl}${url}${param.data[prop]}`;
    } else {
      linkUrl = `${url}${param.data[prop]}`;
    }
  } else if (differenceEntities) {
    if (differenceEntities.isLink) {
      if (differenceEntities.otherAppFlag) {
        linkUrl = `${currentUrl}${differenceEntities.url}${param.data[differenceEntities.prop]}`;
      } else {
        linkUrl = `${differenceEntities.url}${param.data[differenceEntities.prop]}`;
      }
    }
  } else {
    if (otherAppFlag) {
      if (param.node.allLeafChildren) {
        const propValue = param.node.allLeafChildren[0].data[prop];
        linkUrl = `${currentUrl}${url}${propValue}`;
      }
    } else if (param.node.allLeafChildren) {
      const propValue = param.node.allLeafChildren[0].data[prop];
      linkUrl = `${url}${propValue}`;
    }
  }
  if (param.data && (param.data[prop] || (!param.data[prop] && differenceEntities))) {
    return `<a href="${linkUrl}" target="_self" class='grid-link'> ${linkText} </a>`;
  }
  return param.value ? param.value : '';
}

export const LinkCellRenderer = (prop, url, otherAppFlag, differenceEntities) => {
  return function (param) {
    return linkCellRendererUtil({ prop, url, otherAppFlag, differenceEntities, param })
  }
};

export const LinkCellRendererSalesAgents = (prop, url, otherAppFlag, differenceEntities) => {
  return function (param) {
    if (param.data.hasOwnProperty('sale_agent') && param.data.sale_agent) {
      return linkCellRendererUtil({ prop, url: '/sales-agent-invoices/', otherAppFlag, differenceEntities, param })
    }
    return linkCellRendererUtil({ prop, url, otherAppFlag, differenceEntities, param })
  }
}

export const MultiLinkCellRenderer = (prop, url, valueKey, keyParam, otherAppFlag) => {
  return function (param) {
    if (param.data && param.data[prop]) {
      if (otherAppFlag) {
        const currentUrl = window.location.origin;
        const linkArray = param.data[prop].map((e) => {
          return e[valueKey] ? `<a href="${currentUrl}${url}${e[keyParam]}" target="_self" class='grid-link'>  ${e[valueKey]} </a>` : ''
        }).join('|')
        return linkArray;
      }
      const link = param.data[prop].map((e) => {
        return e[valueKey] ? `<a href="${url}${e[keyParam]}" target="_self" class='grid-link'> ${e[valueKey]} </a>` : ''
      }).join('|');
      return link;
    } else {
      if (param.node.allLeafChildren) {
        const fieldName = param.node.field;
        const link = param.node.allLeafChildren[0].data[prop].map((e) => {
          return e[valueKey] ? `<a href="${url}${e[keyParam]}" target="_self" class='grid-link'> ${e[valueKey]} </a>` : ''
        }).join('|');
        return link;
      }
    }
  }
};

const BarPropsSelector = (prop) => {
  return {
    color: prop === Infinity ? '#09f' :
      prop > 90 ? '#00ff00' :
        prop > 80 ? '#ccffcc' :
          prop > 70 ? '#e6e600' :
            prop > 60 ? '#ffffb3' :
              prop > 50 ? '#fff0b3' :
                prop > 40 ? '#ff9900' :
                  prop > 30 ? '#ffc2b3' :
                    prop > 20 ? '#ff8566' : '#ff3300',
  }
};


const FieldsRenderer = (startRangeValue, endRangeValue, showPercent = false, props = null, repackingCheck = false) => {
  if (startRangeValue !== undefined && endRangeValue !== undefined) {
    let percentValue = (startRangeValue / endRangeValue) * 100 || 0;
    let percentViewStr;
    if (!showPercent) {
      percentViewStr = `${percentValue.toLocaleString('ru-RU', {maximumFractionDigits: 2})}%`;
    }
    const barProps = BarPropsSelector(percentValue);
    if (percentValue === Infinity) {
      percentValue = 100;
    }
    if (percentValue > 100) {
      percentValue = 100;
    }
    const exclamatoryMark = props && repackingCheck ? renderService.plainExclamatoryMark()(props) : ''
    return `
      ${exclamatoryMark}
      <div style="background-color: #f1f1f1; position: relative; ${repackingCheck ? 'padding-left: 15px;' : ''}">
          <div style="width:${percentValue}%; background-color: ${barProps.color}; font-size:10px; font-weight: bold; height: 25px">
            <span style="float: left; padding-left: 3px;">${startRangeValue.toLocaleString('ru-RU')}/${endRangeValue.toLocaleString('ru-RU')}</span>
            ${!showPercent ? `<span style="position: absolute; right: 3px">${percentViewStr}</span>` : ''}
          </div>
      </div>`;
  }
};

export const ProgressBarRenderer = (prop) => {
  return function (prop) {
    if (!prop.node.rowPinned && (prop.value || prop.value === 0)) {
      const barProps = BarPropsSelector(prop.value);
      let width = prop.value;
      if (prop.value > 100) {
        width = 100;
      }

      return `<div style="background-color: #f1f1f1"><div align="left" style="height:24px;width:${width}%; background-color: ${barProps.color}"><span style="padding-left: 5px">  ${prop.value} %</span></div></div>`;
    }
  }
};

export const ProgressBarByFieldsRenderer = (startRangeField, endRangeField, repackingCheck) => {
  return function (props) {
    if (props.data) {
      const startRangeValue = props.data[startRangeField], endRangeValue = props.data[endRangeField];
      return FieldsRenderer(startRangeValue, endRangeValue, false, props, repackingCheck);
    }
  }
};

export const ProgressBarInvoiced = (packets) => {
  return function (props) {
    if (props.data && props.data[packets]) {
      const startRangeValue = props.data[packets].filter(item => item.invoice_item__invoice__invoice_number !== null).length;
      const endRangeValue = props.data[packets].length;
      return FieldsRenderer(startRangeValue, endRangeValue, true, props);
    }
  }
};

export const autoResize = (grid) => {
  if (grid && grid.api) {
    const allColumns = grid.columnApi.getAllColumns();
    if (allColumns && allColumns.length) {
      const allColumnIds = allColumns.map(column => column.colId);
      grid.columnApi.autoSizeColumns(allColumnIds);
    }
  }
};

export const notificationsRenderer = (responseData, notificationType, group = 'main', speed = '15000') => {
  function setNotifyData(title, text = '') {
    return {
      group, title, text, type: notificationType, speed
    }
  }

  if (responseData) {
    if (typeof responseData === 'object') {
      for (let key in responseData) {
        if (responseData.hasOwnProperty(key)) {
          if (typeof responseData[key] === 'object') {
            for (let i = 0; i < responseData[key].length; ++i) {
              Vue.notify(setNotifyData(key, responseData[key][i]));
            }
          } else {
            Vue.notify(setNotifyData(key, responseData[key]));
          }
        }
      }
    } else if (typeof responseData === 'string') {
      Vue.notify(setNotifyData(responseData));
    }
  } else {
    Vue.notify(setNotifyData('Application error'));
  }
};

export const countRowsRenderer = (field_name) => {
  return function (params) {
    return `<span>(${params.data[field_name].length})</span>`
  }
};

export const getPinnedRowData = (data, key = 'name', value = 'value') => {
  let pinnedRowData = [{}];
  data.forEach(e => pinnedRowData[0][e[key]] = e[value]);
  return pinnedRowData;
};

/**
 *  function for translation keys
 * @returns {string} translation for input translation key
 */
export function translationCell (data, key = 'name', value = 'value') {
  return this.$t(value)
}

export function booleanRenderer ({ trueValue, falseValue }) {
  return (data) => {
    let render = ``
    if (data.hasOwnProperty('value')) {
      const { value } = data
      if (value === null) {
        return ''
      } else {
        render = `<div class="text-center">
          ${value ? trueValue : falseValue }
        </div>`
      }
    }
    return render
  }
}


// WEBPACK FOOTER //
// ./src/helpers/renderHelpers.js